// src/components/layout/Header.js
import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header
      style={{
        padding: '15px 20px',
        background: 'green',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <h2 style={{ margin: 0 }}>RMS GH</h2>
      {user && (
        <div>
          <span style={{ marginRight: '15px' }}>Welcome, {user.name || 'Admin'}!</span>
          <button
            onClick={handleLogout}
            style={{
              background: '#f00',
              color: 'white',
              border: 'none',
              padding: '8px 12px',
              cursor: 'pointer',
              borderRadius: '4px',
            }}
          >
            Logout
          </button>
        </div>
      )}
    </header>
  );
}

export default Header;
